<template>
  <v-app
    id="app"
    class="b-app"
  >
    <the-spinner
      v-show="requestCounterForSpinnerShown > 0"
      ref="theSpinner"
    />
    <router-view />
  </v-app>
</template>
<script>
/**
 * App vue file management the rotues application.
 *
 * @author C Camilo Castellanos
 * @version 1.0.0
 * @since 18/12/2019 9:48 a. m.
 */
import TheSpinner from './components/layout/TheSpinner'
import { NOT_FOUND } from './shared/constants/httpStatus'
import { GENERAL_PARAMETERS } from './store/mutations-types'
import handleErrorMixin from './mixins/handleErrorMixin'
import { mapState } from 'vuex'

export default {
  name: 'App',
  components: {
    TheSpinner
  },
  mixins: [handleErrorMixin],
  data () {
    return {
      PARAMETROS_GENERALES: `${process.env.VUE_APP_API_URL}parametros-generales/web-app`
    }
  },
  computed: mapState(['requestCounterForSpinnerShown', 'changeLanguage', 'generalParameters']),
  created () {
    if (this.changeLanguage !== null) {
      this.locale = this.changeLanguage
      this.$root.$i18n.locale = this.changeLanguage
    }
    if (!this.generalParameters) {
      this.axios.get(this.PARAMETROS_GENERALES).then((response) => {
        this.$store.commit(GENERAL_PARAMETERS, response.data)
      }).catch(error => {
        if (error.response && error.response.data && error.response.data.statusCode === NOT_FOUND) {
          this.$store.commit(GENERAL_PARAMETERS, {})
          return
        }
        this.$_handleErrorMixin_generateError(error)
      })
    }
  },
  methods: {
    cargarFavico () {
      document.querySelectorAll("link[rel*='icon']").forEach((val, index) => {
        document.querySelectorAll("link[rel*='icon']")[index].href = this.generalParameters.urlFavIcon
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  .b-app {
    height: 100%;
  }
</style>
